export default __webpack_public_path__ + "assets/bg2.7c65c72d.png";